<script setup>
// NOTICE: KAPTION-INTEGRATION — security-center.UI.3: a small status pill
import { computed } from 'vue';

const props = defineProps({
  tone: { type: String, default: 'slate' },
  label: { type: String, required: true },
});

const TONES = {
  teal: 'bg-n-teal-3 text-n-teal-11',
  amber: 'bg-n-amber-3 text-n-amber-11',
  ruby: 'bg-n-ruby-3 text-n-ruby-11',
  slate: 'bg-n-alpha-2 text-n-slate-11',
};
const toneClass = computed(() => TONES[props.tone] || TONES.slate);
</script>

<template>
  <span
    class="px-1.5 py-0.5 text-xs rounded-full whitespace-nowrap"
    :class="toneClass"
  >
    {{ label }}
  </span>
</template>
